// extracted by mini-css-extract-plugin
module.exports = {"fill-text":"Layout_fill-text__Yylr6","Spin":"Layout_Spin__FDJ1P","box":"Layout_box__aBTLX","image":"Layout_image__KBe3V"};